// extracted by mini-css-extract-plugin
module.exports = {"chart":"_stats_chart_1p3h2"};